"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFViewer = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactIframe = _interopRequireDefault(require("react-iframe"));

var _axios = _interopRequireDefault(require("axios"));

var _framerMotion = require("framer-motion");

var _reactFeather = require("react-feather");

var _components = require("../../components");

var _useScrollToTop = _interopRequireDefault(require("../../lib/utils/hooks/useScrollToTop"));

var _variants = require("../../lib/animation/variants");

var _PDFViewer = require("./PDFViewer.style");

var PDFViewer = function PDFViewer(_ref) {
  var data = _ref.data,
      page = _ref.page;
  (0, _useScrollToTop.default)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      blobUrl = _useState2[0],
      setBlobUrl = _useState2[1];

  var navigate = (0, _reactRouterDom.useNavigate)();
  var match = (0, _reactRouterDom.useMatch)();

  if (!data) {
    navigate({
      pathname: '/',
      state: {
        from: match.pathname
      }
    });
  }

  var createBlobUrl = function createBlobUrl(data) {
    var byteCharacters = atob(data);
    var byteNumbers = new Array(byteCharacters.length);

    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], {
      type: 'application/pdf'
    });
    var blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  };

  (0, _react.useEffect)(function () {
    var url;

    if (typeof data === 'string' && data.startsWith('http')) {
      // const _url = data;
      // const parsedResult = new DOMParser().parseFromString(_url, 'text/html');
      // const parsedUrl = parsedResult.documentElement.textContent;
      // url = parsedUrl;
      url = data;
    } else {
      url = createBlobUrl(data);
    }

    setBlobUrl(url);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, null, /*#__PURE__*/_react.default.createElement(_PDFViewer.MenuWrapper, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "Go Back",
    icon: /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronLeft, null),
    onClick: function onClick() {
      window.history.back();
    }
  })), /*#__PURE__*/_react.default.createElement(_PDFViewer.PDFWrapper, null, blobUrl ? /*#__PURE__*/_react.default.createElement(_reactIframe.default, {
    src: "".concat(blobUrl).concat(page ? "#page=".concat(page) : '')
  }) : null));
};

exports.PDFViewer = PDFViewer;